// Components==============
import { useQuery, UseQueryOptions } from "@tanstack/react-query";
import axios from "axios";
// =========================

export const getDatasets = async () => {
  const { data } = await axios.get("/api/datasets");
  return data as DatasetEntity[];
};

export default function useGetDatasets(
  options?: UseQueryOptions<DatasetEntity[]>
) {
  const query = useQuery<DatasetEntity[]>({
    queryKey: ["datasets"],
    queryFn: getDatasets,
    ...options,
  });

  return query;
}
